<template>
    <div class="main-plan-lists">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for="(list, index) in lists" class="swiper-slide">
                    <!-- 기획전 그리드 레이아웃 -->
					<exhibition-list
                    :index = "index"
                    :list-style = "'slide'"
                    >
                    </exhibition-list>
                </div>
            </div>
        </div>
        <div class="main-plan__pagination"></div>
        <div class="main-plan__prev"></div>
        <div class="main-plan__next"></div>
    </div>
</template>

<script>
import ExhibitionList from "@/components/client/exhibition/list.vue";
export default{
	components: {
        ExhibitionList
	},
    data: () => {
        return{
            // 더미 슬라이드
            lists: new Array(10)
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
            this.$nextTick( () => {
				var slidePlan = new Swiper ('.main-plan-lists .swiper-container', {
					allowTouchMove: false,
                    spaceBetween : 36,
                    speed: 400,
                    loop: false,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    watchSlidesVisibility: true,
					preloadImages: false,
					lazy: true,
                    pagination: {
                        el: '.main-plan__pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.main-plan__next',
                        prevEl: '.main-plan__prev'
                    },
					breakpoints: {
                        500: {
                            spaceBetween : 15,
							allowTouchMove: true,
                        },
                        768: {
                            spaceBetween : 15,
							allowTouchMove: true,
                        },
                        1024: {
                            spaceBetween : 15,
							allowTouchMove: true,
                        }
                    }
                });
            });
		}
	},
}
</script>
